// src/contexts/AudioContext.js
import React, { createContext, useContext, useState, useRef } from 'react';

const AudioContext = createContext();

export function useAudio() {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within AudioProvider');
  }
  return context;
}

export function AudioProvider({ children }) {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const playTrack = (track) => {
    // track shape: { audioUrl, trackTitle, artistName, coverArt, releaseId }
    setCurrentTrack(track);
    setIsPlaying(true);
  };

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
  };

  const closePlayer = () => {
    setCurrentTrack(null);
    setIsPlaying(false);
  };

  const setAudioRef = (ref) => {
    audioRef.current = ref;
  };

  return (
    <AudioContext.Provider value={{ 
      currentTrack, 
      isPlaying,
      setIsPlaying,
      playTrack, 
      togglePlayPause,
      closePlayer,
      setAudioRef,
    }}>
      {children}
    </AudioContext.Provider>
  );
}

